//  业务类型 目前只有 letting/sale/management
export const PAGE_MODE = Object.freeze({
  LETTING: 'letting',
  SALE: 'sale',
  MANAGEMENT: 'management',
})

export const SIZE = Object.freeze({
  LARGE: 'large',
  BASE: 'base',
  SMALL: 'small',
})